import { DataSection, HitData, HitReprocessed, ResultDataNew, ResultType } from "../../enums/index.js";
import SerializedParameterFormatter from "../SerializedParameterFormatter.js";

class HitPointFormatter extends SerializedParameterFormatter{
    constructor(dataParameter, mapExtractedTo, emptyValue, separator, singleValueParser, throwOnError, isOptional, newStructureSection) {
        super(
            dataParameter || HitData.HitPoint,
            mapExtractedTo || {
                X: HitReprocessed.HitSideR.key,
                Y: HitReprocessed.HitDistanceR.key,
                Z: HitReprocessed.HitHeightR.key,
            },
            emptyValue,
            separator,
            singleValueParser,
            throwOnError,
            isOptional,
            newStructureSection
        );
    }

    static forNewStructure(dataParameter, mapExtractedTo, emptyValue, separator, singleValueParser, throwOnError, isOptional) {
        return new HitPointFormatter(
            dataParameter, mapExtractedTo, emptyValue, separator, singleValueParser, throwOnError, isOptional,
            [ResultDataNew.Data.key, DataSection.Sensor.key, ResultType.Hit.key]
        );
    }
}

export default HitPointFormatter;